function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.11699 13.6798C7.86232 10.5545 8.59165 7.42514 9.36232 4.30781C9.87299 2.24781 10.7103 1.67847 12.7343 2.16114C16.9183 3.16114 21.0903 4.21847 25.2543 5.29581C27.025 5.75181 27.625 6.75314 27.2037 8.54647C25.6797 15.0198 24.133 21.4851 22.565 27.9478C22.1503 29.6558 21.1797 30.2865 19.5023 29.8825C15.161 28.8358 10.8277 27.7465 6.50099 26.6291C4.89565 26.2131 4.38765 25.2171 4.80765 23.3838C5.54899 20.1411 6.34365 16.9118 7.11699 13.6798Z",
  fill: "#FF3819"
});

var SvgRedCard = function SvgRedCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRedCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/redCard.4db58717.svg";
export { ForwardRef as ReactComponent };